<template>
  <v-container fill-height justify-content-start :class="{'pa-2': $vuetify.breakpoint.xsOnly}" class="app-section-width">
    <v-layout column>
      <v-toolbar color="white" flat>
        <v-btn icon light @click="exit()">
          <v-icon color="grey darken-2">mdi-arrow-left</v-icon>
        </v-btn>
        <v-toolbar-title class="grey--text text--darken-4 pa-0">{{ $t('headers.guest_checkin_completed') }}</v-toolbar-title>
      </v-toolbar>
      <v-flex class="app-scroll-section">
        <div class="guest-checkin-completed-title">
          {{ $t('headers.personal_data') }}
        </div>
        <v-text-field
          :label="$t('fields.name')"
          :value="name"
          outlined
          readonly
        ></v-text-field>
        <v-text-field
          :label="$t('fields.surname')"
          :value="lastName"
          outlined
          readonly
        ></v-text-field>
        <v-text-field
          :label="$t('fields.birthdate')"
          :value="dateOfBirth"
          append-icon="mdi-calendar"
          outlined
          readonly
        ></v-text-field>
        <v-select
          :label="$t('fields.gender')"
          v-model="gender"
          :items="genders"
          item-text="name"
          item-value="id"
          outlined
          readonly
          append-icon="false"
        >
          <template v-slot:selection="{ item }">
            {{$t(`gender.${item.id}`)}}
          </template>
          <template v-slot:item="{ item }">
            {{$t(`gender.${item.id}`)}}
          </template>
        </v-select>
        <v-text-field
          :label="documentType ? $t('document_type.' + documentType.toUpperCase()) : null"
          :value="documentId"
          outlined
          readonly
        ></v-text-field>
        <v-text-field
          :label="$t('fields.address')"
          :value="address"
          outlined
          readonly
        ></v-text-field>
        <v-text-field
          :label="$t('fields.document_expiration')"
          :value="dateOfExpiry"
          append-icon="mdi-calendar"
          outlined
          readonly
        ></v-text-field>
        <div class="guest-checkin-completed-title">
          {{ $t('headers.contact_data') }}
        </div>
        <template v-for="(field, index) in contactFields">
          <v-autocomplete
            :key="index"
            v-if="field.name === 'languageCode'"
            :label="field.label"
            outlined
            :items="allowedLanguageCodes"
            :value="contactDataFieldValue(field.name)"
            item-text="name"
            item-value="value"
            readonly
            append-icon=""
          >
            <template v-slot:selection="{ item }">
              {{languages[item].native}}
            </template>
            <template v-slot:item="{ item }">
              {{languages[item].native}}
            </template>
          </v-autocomplete>
          <v-text-field
            :key="index"
            v-else
            :label="field.label"
            :value="contactDataFieldValue(field.name)"
            outlined
            readonly
          ></v-text-field>
        </template>
        <!-- <div class="guest-checkin-completed-title">
          {{ $t('headers.terms_of_service') }}
        </div>
        <v-btn v-if="registrationCards.tosSignature && registrationCards.tosSignature.tosFileId" @click="downloadSignedFile()" color="primary darken-1" class="mb-10" height="48">
          <v-icon left>mdi-download</v-icon> {{ $t('actions.download_signed_document') }}
        </v-btn> -->
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment'
import { camelCase } from 'lodash'
import routeNames from '@/router/routes'
import router from '@/router'
import { mapState, mapGetters } from 'vuex'
import ServerDirections from '@/config/server-directions'
import { RequestService } from '@/services/request.service'
import { genders, standardContactFields } from '@/config'
import languages from '@/data/languages'
const requestService = new RequestService()
export default {
  data () {
    return {
      genders,
      languages,
      standardContactFields,
    }
  },
  computed: {
    ...mapGetters('me', ['allowedLanguageCodes']),
    id () {
      return this.$route.params.guestId
    },
    verifiedDocumentData () {
      return this.registrationCards.verifiedDocumentData
    },
    contactData () {
      let contactData = this.registrationCards.contactData
      if (contactData) {
        contactData.additionalData = contactData.additionalData.map((data) => {
          data.fieldName = camelCase(data.fieldName)
          return data
        })
      }
      return contactData
    },
    registrationCardConfiguration () {
      return this.service.configuration ? this.service.configuration.registrationCardConfiguration : null
    },
    name () {
      return this.verifiedDocumentData && this.verifiedDocumentData.name
        ? this.verifiedDocumentData.name
        : null
    },
    lastName () {
      return this.verifiedDocumentData && this.verifiedDocumentData.lastName
        ? this.verifiedDocumentData.lastName
        : null
    },
    dateOfBirth () {
      return this.verifiedDocumentData && this.verifiedDocumentData.dateOfBirth
        ? moment(this.verifiedDocumentData.dateOfBirth).local().format('L')
        : null
    },
    gender () {
      return this.verifiedDocumentData && this.verifiedDocumentData.sex
        ? this.verifiedDocumentData.sex.toLowerCase()
        : null
    },
    documentType () {
      return this.verifiedDocumentData && this.verifiedDocumentData.documentType
        ? this.verifiedDocumentData.documentType
        : null
    },
    documentId () {
      return this.verifiedDocumentData && this.verifiedDocumentData.documentId
        ? this.verifiedDocumentData.documentId
        : null
    },
    address () {
      return this.verifiedDocumentData && this.verifiedDocumentData.address
        ? this.verifiedDocumentData.address
        : null
    },
    dateOfExpiry () {
      return this.verifiedDocumentData && this.verifiedDocumentData.dateOfExpiry
        ? moment(this.verifiedDocumentData.dateOfExpiry).local().format('L')
        : null
    },
    contactFields () {
      if (!this.registrationCardConfiguration) {
        return []
      }
      let languageCode = this.$i18n.locale
      let contactData = this.registrationCardConfiguration.steps.find(step => step.type === 'CONTACT_DATA')
      return contactData.configuration.fields.map((field) => {
        let name = field.name.filter(name => name.languageCode === languageCode)[0]
        return {
          label: name.value,
          name: camelCase(field.fieldName),
          required: field.required,
        }
      })
    },
    ...mapState(['registrationCards', 'service']),
  },
  methods: {
    contactDataFieldValue (fieldName) {
      if (!this.contactData) {
        return null
      }
      if (standardContactFields.includes(fieldName)) {
        return this.contactData[fieldName]
      } else {
        const field = this.contactData.additionalData.find((f) => f.fieldName === fieldName)
        if (field) {
          return field.value
        } else {
          return null
        }
      }
    },
    async downloadSignedFile () {
      let fileId = this.registrationCards.tosSignature.tosFileId
      const token = await requestService.authHeader().catch((error) => {
        return new Promise((resolve, reject) => {
          reject(error)
        })
      })
      window.open(ServerDirections.DOCUMENT_SIGNED_FILE.replace('{guestId}', this.id).replace('{fileId}', fileId) + `?x-api-key=${ token }`)
    },
    exit () {
      router.push({ name: routeNames.checkin.name })
    },
  },
  created () {
    moment.locale(this.locale)
    this.$store.dispatch('registrationCards/get', { guestId: this.id }).catch(() => {})
  },
  beforeDestroy () {
    this.$store.commit('registrationCards/resetRegistrationCardState')
  },
}
</script>

<style lang="scss">
#guest-checkin-completed {
  max-width: 430px !important;
  padding: 15px 15px 0 15px;

  .v-toolbar__content {
    padding: 0;
  }
}

.guest-checkin-completed-block {
  margin-bottom: 30px;
}

.guest-checkin-completed-title {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.6);
  font-weight: 500;
  margin-bottom: 16px;
}

#content {
  overflow-y: auto;
}
</style>
